import { render, staticRenderFns } from "./product-img.vue?vue&type=template&id=546a1f2c&scoped=true&"
var script = {}
import style0 from "./product-img.vue?vue&type=style&index=0&id=546a1f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546a1f2c",
  null
  
)

export default component.exports